import MatterTeamsCard from "@/components/features/settings/defaults/matter-teams/MatterTeamsCard";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/intake/teams")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.intakeSettingsTeams)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <MatterTeamsCard title="Intake teams" addButtonLabel="Add intake team" />
  );
}
